import { render, staticRenderFns } from "./ProductMediaSelectView.vue?vue&type=template&id=0d8c3d6e&scoped=true&"
import script from "./ProductMediaSelectView.vue?vue&type=script&lang=js&"
export * from "./ProductMediaSelectView.vue?vue&type=script&lang=js&"
import style0 from "./ProductMediaSelectView.vue?vue&type=style&index=0&id=0d8c3d6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c3d6e",
  null
  
)

export default component.exports